/**
 * How wide an animal name's widest word is, in em, set in a bold sans-serif
 * (D-116).
 *
 * A card's name sizes itself so that word fits on one line — `.card__name` in
 * app.css reads this as `--name-em` — because a name may wrap between words
 * ("Snow / Leopard") but should never break inside one ("Velocirap / tor").
 * A letter count was not enough: "Hammerhead" (10 letters, three wide ones)
 * renders wider than "Velociraptor" (12). The table is Avenir Next Bold's
 * advance widths, which SF Pro, Segoe UI and Roboto bold sit within a few
 * percent of; `--name-fit` in tokens.css is the margin on top of the estimate.
 * Hyphens are break points too, so "Blue-Ringed" is two words.
 */
const EM = {
  a: 0.57, b: 0.63, c: 0.54, d: 0.63, e: 0.58, f: 0.36, g: 0.63, h: 0.61, i: 0.26, j: 0.26, k: 0.57, l: 0.26, m: 0.93,
  n: 0.61, o: 0.62, p: 0.63, q: 0.63, r: 0.39, s: 0.48, t: 0.37, u: 0.61, v: 0.55, w: 0.83, x: 0.54, y: 0.55, z: 0.48,
  A: 0.70, B: 0.65, C: 0.69, D: 0.74, E: 0.60, F: 0.57, G: 0.74, H: 0.74, I: 0.27, J: 0.47, K: 0.66, L: 0.52, M: 0.89,
  N: 0.74, O: 0.79, P: 0.63, Q: 0.79, R: 0.65, S: 0.57, T: 0.57, U: 0.74, V: 0.67, W: 1.0, X: 0.65, Y: 0.61, Z: 0.63,
}
const OTHER = 0.6 // digits, apostrophes, accents — anything the table does not name

export function widestWordEm(name) {
  let widest = 0
  for (const word of String(name).split(/[\s-]+/)) {
    let em = 0
    for (const ch of word) em += EM[ch] ?? OTHER
    if (em > widest) widest = em
  }
  return Math.round(Math.max(widest, 1) * 100) / 100
}
